module.exports = __webpack_public_path__ + "static/img/activity_sdy_06-4.c5b453a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_06-4.jpg
// module id = 1xVB
// module chunks = 0